import Vue       from 'vue'
import Vuex      from 'vuex'
import localdata from './services/localdata.service'

Vue.use(Vuex);

const dummyCurrency = {
  id: '',
  symbol: '',
  decimals: 2
};

const handlers = {
  lang: {
    set: 'lang_set'
  },
  adminTimezone: {
    set: 'adminTimezone_set'
  },
  admin: {
    set: 'admin_set'
  },
  client: {
    set: 'client_set'
  },
  currencies: {
    set: 'currencies_set'
  },
  breadcrumbs: {
    setBreadcrumb: 'breadcrumbs_set_breadcrumb'
  },
  editPlayer: {
    set: 'editPlayer_set'
  },
  timezones: {
    set: 'timezones_set'
  }
};

const store = new Vuex.Store({
  state: {
    availableLanguages: ['ru', 'en'],
    lang: 'en',
    adminTimezone: localdata.getTimezone() || { id: 'UTC', offset: 0 },
    admin: null,
    client: null,
    currencies: [],
    dynamicBreadcrumbs: [],
    editPlayer: null,
    timezones: []
  },
  getters: {
    availableLanguages: state => state.availableLanguages,
    lang: state => state.lang,
    adminTimezone: state => state.adminTimezone,
    admin: state => state.admin,
    client: state => state.client,
    currencies: state => state.currencies,
    dynamicBreadcrumbs: state => state.dynamicBreadcrumbs,
    editPlayer: state => state.editPlayer,
    timezones: state => state.timezones
  },
  actions: {
    [handlers.lang.set]: ({ commit }, lang) => commit(handlers.lang.set, lang),
    [handlers.adminTimezone.set]: ({ commit }, adminTimezone) => commit(handlers.adminTimezone.set, adminTimezone),
    [handlers.admin.set]: ({ commit }, admin) => commit(handlers.admin.set, admin),
    [handlers.client.set]: ({ commit }, client) => commit(handlers.client.set, client),
    [handlers.currencies.set]: ({ commit }, currencies) => commit(handlers.currencies.set, currencies),
    [handlers.breadcrumbs.setBreadcrumb]: ({ commit }, breadcrumb) => commit(handlers.breadcrumbs.setBreadcrumb, breadcrumb),
    [handlers.editPlayer.set]: ({ commit }, player) => commit(handlers.editPlayer.set, player),
    [handlers.timezones.set]: ({ commit }, timezones) => commit(handlers.timezones.set, timezones)
  },
  mutations: {
    [handlers.lang.set]: (state, lang) => state.lang = lang,
    [handlers.adminTimezone.set]: (state, adminTimezone) => state.adminTimezone = adminTimezone,
    [handlers.admin.set]: (state, admin) => state.admin = admin,
    [handlers.client.set]: (state, client) => state.client = client,
    [handlers.currencies.set]: (state, currencies) => state.currencies = currencies,
    [handlers.breadcrumbs.setBreadcrumb]: (state, breadcrumb) => {
      let isNew  = true;
      state.dynamicBreadcrumbs.forEach(b => {
        if (b.key === breadcrumb.key) {
          b.func = breadcrumb.func;
          isNew = false;
        }
      });
      if (isNew) {
        state.dynamicBreadcrumbs.push(breadcrumb);
      }
    },
    [handlers.editPlayer.set]: (state, player) => state.editPlayer = player,
    [handlers.timezones.set]: (state, timezones) => state.timezones = timezones
  }
});

export default {
  store,
  availableLanguages: {
    get: () => store.getters.availableLanguages
  },
  lang: {
    get: () => {
        let localLang = localdata.getLanguage();
        if (localLang && store.getters.lang != localLang) {
            store.dispatch(handlers.lang.set, localLang);
            Vue.i18n.set(localLang);
        }
        return store.getters.lang;
    },
    set: lang => {
      store.dispatch(handlers.lang.set, lang);
      localdata.storeLanguage(lang);
      Vue.i18n.set(lang);
    }
  },
  adminTimezone: {
    get: () => store.getters.adminTimezone,
    set: adminTimezone => {
      store.dispatch(handlers.adminTimezone.set, adminTimezone);
      localdata.storeTimezone(adminTimezone);
    }
  },
  admin: {
    get: () => store.getters.admin,
    set: admin => store.dispatch(handlers.admin.set, admin),
    unset: () => store.dispatch(handlers.admin.set, null)
  },
  client: {
    get: () => store.getters.client,
    set: client => store.dispatch(handlers.client.set, client),
    unset: () => store.dispatch(handlers.client.set, null)
  },
  currencies: {
    get: () => store.getters.currencies,
    getCurrency: currencyId => store.getters.currencies.filter(c => c.id === currencyId)[0] || dummyCurrency,
    set: currencies => store.dispatch(handlers.currencies.set, currencies)
  },
  dynamicBreadcrumbs: {
    get: () => store.getters.dynamicBreadcrumbs,
    setBreadcrumb: breadcrumb => store.dispatch(handlers.breadcrumbs.setBreadcrumb, breadcrumb)
  },
  editPlayer: {
    get: () => store.getters.editPlayer,
    set: player => store.dispatch(handlers.editPlayer.set, player),
    unset: () => store.dispatch(handlers.editPlayer.set, null)
  },
  timezones: {
    get: () => store.getters.timezones,
    getTimezone: timezoneId => store.getters.timezones.filter(tz => tz.id === timezoneId)[0] || { id: 'UTC', offset: 0 },
    set: timezones => store.dispatch(handlers.timezones.set, timezones)
  }
}



// WEBPACK FOOTER //
// ./src/state.js